import { useHandlerQuery } from '../../useHandlerQuery';

export const useGetContact = ({ contactId }: { contactId: string }) =>
  useHandlerQuery((api) => api.contact().getContact(contactId), {
    key: ['CONTACTS', contactId],
  });
